import * as pbi from 'powerbi-client/dist/powerbi.min';

export default function powerbi ({ req, app }, inject) {
    inject('powerbi', pbi);
}
